(function(){
  if(window.__bmpSelImgInit)return;window.__bmpSelImgInit=true;
  var imgMap={
    'processeur':'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&q=70&w=800',
    'cpu':'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&q=70&w=800'
  };
  var ORDER_PRIORITY={'clavier':1,'apparence':2,'etat':2,'processeur':3,'cpu':3,'stockage':4,'ssd':4,'memoire':5,'ram':5};
  function norm(s){return (s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'');}
  function getPriority(sel){
    if(sel.dataset.bmpOrder)return parseInt(sel.dataset.bmpOrder,10);
    var titleEl=sel.querySelector('.bmp-selector-title');
    if(!titleEl)return 99;
    var title=norm(titleEl.textContent);
    var p=99;
    Object.keys(ORDER_PRIORITY).forEach(function(k){if(title.indexOf(k)>=0 && ORDER_PRIORITY[k]<p)p=ORDER_PRIORITY[k];});
    return p;
  }
  function run(){
    var container=document.querySelector('.bmp-selectors');
    if(!container)return;
    var selectors=Array.from(container.querySelectorAll('.bmp-selector'));
    if(!selectors.length)return;
    selectors.sort(function(a,b){return getPriority(a)-getPriority(b);});
    selectors.forEach(function(sel){container.appendChild(sel);});
    selectors.forEach(function(sel){
      if(sel.dataset.bmpImgApplied)return;
      var titleEl=sel.querySelector('.bmp-selector-title');
      if(!titleEl)return;
      var title=norm(titleEl.textContent);
      var url=null;
      Object.keys(imgMap).forEach(function(k){if(!url&&title.indexOf(k)>=0)url=imgMap[k];});
      if(!url)return;
      var right=document.createElement('div');
      right.className='bmp-selector-right';
      while(sel.firstChild)right.appendChild(sel.firstChild);
      var img=document.createElement('div');
      img.className='bmp-selector-img';
      img.style.backgroundImage='url('+url+')';
      sel.appendChild(img);
      sel.appendChild(right);
      sel.classList.add('bmp-selector--grid');
      sel.dataset.bmpImgApplied='1';
    });
    container.classList.add('bmp-selectors--wide');
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
